import React, {FC, memo} from 'react';
import styled from 'styled-components';
// Import Styles
import P from '../../components/Paragraph';

interface INoResults {
  message?: string;
}

const NoResults: FC<INoResults> = ({message}) => {

  return (
    <NoResultsWrapper><P>{message ? message : "No results"}</P></NoResultsWrapper>
  )
}

const NoResultsWrapper = styled.div`
  text-align: center;
  width: 100%;
  padding: 24px 0;

  p {
    font-size: 18px;
    font-weight: 600;
    margin: 0;
  }
`;

export default memo(NoResults);
